import React from 'react';
// Data
import { largeGalleryImagesArray } from '../../utils/data/GalleryData';
// Constants
import { CompanyName } from '../../utils/Constants';
// Components
// import SmallSocialCta from '../socialMedia/SmallSocialCta';

function GalleryPageMainContainer() {
  return (
    <main
      role='main'
      className='grid gap-6 relative w-full h-full overflow-hidden pt-12 pb-12'
    >
      <section className='grid px-6 sm:px-6 md:px-12'>
        <div className='grid lg:max-w-[55vw] lg:mx-auto gap-4 px-6 py-6 lg:py-8 lg:px-10 lg:text-lg text-center shadow-cardShadowBold shadow-colour4/60 dark:shadow-colour4/60 bg-colour4 darlk:bg-colour4'>
          <section className='grid mx-auto text-center'>
            <h4 className='font-StencilW01 tracking-widest text-2xl md:text-3xl font-semibold lg:text-4xl'>
              View My Gallery
            </h4>
          </section>
          <p className='text-xl lg;text-2xl '>
            <strong>Welcome</strong> to my exclusive photo gallery, a collection
            of moments that capture elegance, confidence, and the artistry of
            sexual expression.
          </p>
          <p className='leading-5'>
            Every image tells a story—one of strength, passion, and
            authenticity. My journey is about embracing individuality, pushing
            boundaries, and celebrating the beauty of personal empowerment. Step
            inside and explore the essence of <strong>{CompanyName}</strong>.
          </p>
        </div>
      </section>

      {/* Main */}
      <section className='grid container mx-auto w-full h-full justify-center items-center py-6 px-6 overflow-hidden z-10'>
        <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-y-8 gap-4 lg:gap-y-10'>
          {largeGalleryImagesArray.map((image, index) => {
            // Cycle through bg-colour4, bg-colour5, bg-colour6
            const bgColor =
              index % 3 === 0
                ? 'bg-colour4'
                : index % 3 === 1
                ? 'bg-colour5'
                : 'bg-colour6';

            return (
              <div key={index} className='flex flex-col items-center'>
                <div className={`p-2 sm:p-3 lg:p-3 ${bgColor} h-full shadow-cardShadowBold`}>
                  <img
                    src={image.src}
                    alt={image.alt}
                    className='w-full h-full max-h-[80vh] lg:max-h-[60vh] object-fill md:object-cover shadow-cardShadowBold shadow-colour4/80'
                    loading='lazy'
                  />
                </div>
                <div
                  className={`${bgColor} w-full mt-2 shadow-cardShadow shadow-colour4/80`}
                >
                  <p className='font-semibold text-center'>{image.name}</p>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* Twiter cta */}
{/* 
      <div className='py-8 lg:py-12 xl:py-16'>
        <SmallSocialCta />
      </div> */}
    </main>
  );
}

export default GalleryPageMainContainer;